module.exports = __webpack_public_path__ + "img/1519273760.3950d5f9.jpg";